import {ELEMENT_IDS} from "../MobileDOM";
import Wallet, {WALLET_EVENTS} from "../../../wallet/Wallet";
import {
    creditToMoney,
    getCreditBet,
    getCoin,
    moneyToReal,
    withCurrency
} from "../../../wallet/walletOperations";
import {getNoUISliderRange} from "../../../helpers";
import {injectable} from "inversify";
import IEventObserver from "../../../events/IEventObserver";


export const UISLIDER_EVENTS = {
    "UISLIDER_CHANGE_LINES": "UISLIDER_CHANGE_LINES"
};

@injectable()
abstract class AbstractUISlider implements IEventObserver {

    protected _slider: any;
    protected _wallet: Wallet;
    protected _decimals: boolean

    protected constructor(wallet: Wallet, slider: any, range: Array<any>, value: number, allowedValues: Array<any>, decimals: boolean = false) {

        this._slider = slider;
        this._wallet = wallet;
        this._decimals = decimals;

        this._createSlider(slider, range);
        this.__update(value, allowedValues);
    }

    abstract notify(eventName: string, data?: any, prevData?: any): Promise<any>|void;

    private _createSlider(slider: any, range: Array<any>) {

        let update = {range: getNoUISliderRange(range, this._decimals ? this._wallet.getDecimalPlaces() : undefined), start: null};
        if(range.length === 1) {
            update.start = range[0];
        }

        slider.noUiSlider.updateOptions(update, false);

        slider.querySelectorAll(".noUi-value").forEach((el) => {
            let value = el.getAttribute("data-value") * 1;
            el.addEventListener("click", (e) => {
                slider.noUiSlider.set(value /*e.target.getAttribute("data-value") * 1*/);
            });
        });
    }

    public setValue(value) {
        this._slider.noUiSlider.set(value);
    }

    protected _onSetEvent() {

        let slider = this._slider;
        let lastValue = $(slider).data("lastValue");
        let value = slider.noUiSlider.get() * 1;

        if(value == lastValue) {
            return;
        }

        if(this._sliderCanChange(value)) {

            // @ts-ignore
            let creditBet = document.getElementById(ELEMENT_IDS.SLIDER_BET).noUiSlider.get() * 1;
            // @ts-ignore
            let coinValue = document.getElementById(ELEMENT_IDS.SLIDER_COIN).noUiSlider.get() * 1;
            // @ts-ignore
            let linesCount = document.getElementById(ELEMENT_IDS.SLIDER_LINES).noUiSlider.get() * 1;

            $(slider).data("lastValue", value);

            let data = this._wallet.recalcBets({creditBet, coinValue, linesCount});
            this._update(data);

            AbstractUISlider.sliderPreviewBets(this._wallet);
        } else {
            this.setValue(lastValue);
        }
    }

    private _sliderCanChange(value) {

        if(!value) {
            return false;
        }

        let allowedValues = $(this._slider).data("allowedValues");
        if(allowedValues != null) {
            return allowedValues.includes(value);
        }

        return false;
    }

    protected abstract _update(data?)

    protected __update(value, allowedValues = null) {

        let slider = this._slider;

        slider.querySelectorAll(".noUi-value").forEach((el) => {

            let value = el.getAttribute("data-value") * 1;

            $(el).prev().removeClass("noUi-marker-disabled");
            el.classList.remove("noUi-value-disabled");

            if(allowedValues !== null) {
                if(!allowedValues.includes(value)) {
                    $(el).prev().addClass("noUi-marker-disabled");
                    el.classList.add("noUi-value-disabled");
                }
            }
        });

        $(slider).data("lastValue", value);
        $(slider).data("allowedValues", allowedValues);
    }

    public static sliderPreviewBets(wallet) {
        let betInCash = document.getElementById(ELEMENT_IDS.BET_IN_CASH);
        let betInCoins = document.getElementById(ELEMENT_IDS.BET_IN_COINS);

        // @ts-ignore
        let bet = document.getElementById(ELEMENT_IDS.SLIDER_BET).noUiSlider.get() * 1;
        // @ts-ignore
        let lines = document.getElementById(ELEMENT_IDS.SLIDER_LINES).noUiSlider.get() * 1;
        // @ts-ignore
        let coinValue = document.getElementById(ELEMENT_IDS.SLIDER_COIN).noUiSlider.get() * 1;

        let decimals = wallet.getDecimalPlaces();
        let coin = getCoin(coinValue);

        let moneyBet = creditToMoney(bet * lines, coin, decimals);
        let realBet = moneyToReal(moneyBet, decimals);

        betInCash.innerHTML = withCurrency(realBet, wallet.getCurrency(), decimals);
        betInCoins.innerHTML = getCreditBet(bet, lines) + "";
    }

}

export default AbstractUISlider;